// export const {
//   getDetailStart,
//   getDetailSucceeded,
//   getDetailFailed,
//   getPagedStart,
//   getPagedFailed,
//   getPagedSucceeded,
//   getCountStart,
//   getCountFailed,
//   getCountSucceeded,
//   createStart,
//   createSucceeded,
//   createFailed,
//   updateStart,
//   updateSucceeded,
//   updateFailed,
//   removeStart,
//   removeSucceeded,
//   removeFailed,
// } = generateActions<IAsset, number, ICreateAsset, IUpdateAsset>(
//   GENERATOR_PARAMS,
// );
export var _ = function () { };
